<template>
  <div>
    <vx-card>
      <create-user-side-bar :visible="sideBarVisable">
        <vs-button type="border round" block icon="icon-x" icon-pack="feather" @click="closeAddSideBar">Anuluj</vs-button>
      </create-user-side-bar>
      <b-container fluid>
        <b-row class="mb-6">
          <b-col class="flex flex-row-reverse">
            <vs-button  type="filled round" icon-pack="feather" icon="icon-user-plus"
                        v-if="$acl.check('admin')" class="ml-6" @click="openAddSideBar" >
              Dodaj użytkownika
            </vs-button>
            <vs-input v-model="filter" placeholder="Wyszukaj" class="w-25"></vs-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              hover
              :items="users"
              :fields="usersFields"
              :filter="filter"
              select-mode="single"
              selectable
              @row-selected="onRowSelected"
            >
              <template v-slot:cell(gender)="data">
                {{data.item.gender === 'male' ? 'mężczyzna' : 'kobieta'}}
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-container>
    </vx-card>
  </div>
</template>

<script>
import notification from './../../notification'
import FieldError from './../../components/wod/forms/FieldError'
import {fetchUsers} from './../../mixins/users/usersMixin'
import CreateUserSideBar from './users/CreateUserSideBar'

export default {
  name: "Users",
  mixins: [fetchUsers],
  components: {
    FieldError,
    CreateUserSideBar,
  },
  data(){
    return{
      usersFields: [
        { key: 'first_name', label: 'Imię', sortable: true },
        { key: 'last_name', label: 'Nazwisko', sortable: true },
        { key: 'gender', label: 'płeć'},
        { key: 'type', label: 'Typ', sortable: true},
        { key: 'employment_company', label: 'Placówka'}
      ],
      filter: '',
      formErrors: null,
      sideBarVisable: false,
    }
  },
  methods: {
    openAddSideBar() {
      this.sideBarVisable = true
    },
    closeAddSideBar() {
      this.sideBarVisable = false

    },
    onRowSelected(items){
      this.$router.push({ name: 'users_single', params: { uuid: items[0].uuid }})
    }
  }
}
</script>

